import { coverflow_data } from '@/data/coverflow_data'
import { apiGet, apiGetPromise } from '@/helper/api'
import  { useState } from 'react'

const useCoverFlow = () => {
    const [coverFlowData, setCoverFlowData] = useState()
 
    const getCoverFlow = () => {
        apiGetPromise(`/data/Collection?pageSize=40&offset=0&where=showTop%3Dtrue&loadRelations=collectionTags%2CcollectionAttributes.collectionAttributeValues.collectionAttributeValueUtilities%2CcollectionAttributes%2CcollectionAttributes.collectionAttributeValues%2CcommunityOwner`)
        .then((res) => {
          const items = res?.map(item => ({
            ...item,
            id:item?.objectId,
            img: item?.image,
            title: item?.name,
            authorImage: item?.communityOwner?.profileImage,
            authorName: item?.communityOwner?.name,
           
          }))
          setCoverFlowData(items)
        })
    }
  return {getCoverFlow,coverFlowData}
}

export default useCoverFlow